module.exports = __webpack_public_path__ + "static/img/Bachelor_010447.6d81b1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010447.jpg
// module id = 166
// module chunks = 0